// pages/Products.jsx
import React,{useEffect} from "react";
import "./Products.css";
import AnabolicsSteroid from "./AnabolicsSteroid";
import SARMs from "./SARMs";

const Products = () => {
  // Scroll to top on mount
      useEffect(() => {
        window.scrollTo(0, 0);
      }, []);

  return (
    <div>
    <AnabolicsSteroid/>
    <SARMs/>
    </div>
  );
};

export default Products;
